/** Deterministic, pleasant avatar colors derived from a user id / email. */
/**
 * Hues are drawn from the same Tailwind family rivets.dev uses (it ships
 * Tailwind, and its status messages use emerald-500 / red-500), so avatars stay
 * coherent with the brand while remaining distinguishable from each other and
 * from the achromatic brand accent.
 */
const PALETTE = [
  "#10b981", // emerald-500 — matches the landing page's success tone
  "#3b82f6", // blue-500
  "#8b5cf6", // violet-500
  "#ec4899", // pink-500
  "#f59e0b", // amber-500
  "#06b6d4", // cyan-500
  "#f43f5e", // rose-500
  "#84cc16", // lime-500
  "#6366f1", // indigo-500
  "#94a3b8", // slate-400
];

function hashString(input: string): number {
  let h = 0;
  for (let i = 0; i < input.length; i++) {
    h = (h << 5) - h + input.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}

export function colorForId(id: string): string {
  const idx = hashString(id) % PALETTE.length;
  return PALETTE[idx]!;
}

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return `${parts[0]![0]}${parts[parts.length - 1]![0]}`.toUpperCase();
}
